import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../config';

const CATEGORY_ICONS = {
  transporte: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" /></svg>,
  espacio: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z" /></svg>,
  herramienta: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17l-5.1 5.1a2.121 2.121 0 11-3-3l5.1-5.1m0 0L15 9.59m-3.58 5.58L21 5.17m-5.24 3.35l-2.12-2.12" /></svg>,
  servicio: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z" /></svg>,
  educacion: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" /></svg>,
  alimento: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 8.25v-1.5m0 1.5c-1.355 0-2.697.056-4.024.166C6.845 8.51 6 9.473 6 10.608v2.513m6-4.871c1.355 0 2.697.056 4.024.166C17.155 8.51 18 9.473 18 10.608v2.513M15 8.25v-1.5m-6 1.5v-1.5m12 9.75l-1.5.75a3.354 3.354 0 01-3 0 3.354 3.354 0 00-3 0 3.354 3.354 0 01-3 0 3.354 3.354 0 00-3 0 3.354 3.354 0 01-3 0L3 16.5m15-3.379a48.474 48.474 0 00-6-.371c-2.032 0-4.034.126-6 .371m12 0c.39.049.777.102 1.163.16 1.07.16 1.837 1.094 1.837 2.175v5.169c0 .621-.504 1.125-1.125 1.125H4.125A1.125 1.125 0 013 20.625v-5.17c0-1.08.768-2.014 1.837-2.174A47.78 47.78 0 016 13.12M12.265 3.11a.375.375 0 11-.53 0L12 2.845l.265.265z" /></svg>,
  tecnologia: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" /></svg>,
  otro: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z" /></svg>,
};

const STATUS_LABELS = {
  open: { text: 'Abierto', color: 'bg-green-100 text-green-700' },
  active: { text: 'Activo', color: 'bg-blue-100 text-blue-700' },
  completed: { text: 'Completado', color: 'bg-gray-100 text-gray-600' },
  cancelled: { text: 'Cancelado', color: 'bg-red-100 text-red-600' },
};

const DURATION_LABELS = { once: 'Una vez', hourly: 'Por hora', daily: 'Por dia', weekly: 'Semanal', monthly: 'Mensual' };

// Componente reusable: estrellas (display + selector)
const Stars = ({ value = 0, max = 5, size = 'sm', interactive = false, onChange }) => {
  const [hover, setHover] = useState(0);
  const sizeCls = size === 'lg' ? 'w-8 h-8' : size === 'md' ? 'w-5 h-5' : 'w-4 h-4';
  return (
    <div className="flex items-center gap-0.5" data-testid="stars-display">
      {[1, 2, 3, 4, 5].map(i => {
        const filled = interactive ? (hover || value) >= i : value >= i - 0.5;
        return (
          <svg
            key={i}
            className={`${sizeCls} ${filled ? 'text-yellow-400' : 'text-gray-300'} ${interactive ? 'cursor-pointer transition-transform hover:scale-110' : ''}`}
            fill="currentColor"
            viewBox="0 0 20 20"
            onMouseEnter={() => interactive && setHover(i)}
            onMouseLeave={() => interactive && setHover(0)}
            onClick={() => interactive && onChange && onChange(i)}
            data-testid={interactive ? `star-${i}` : undefined}
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        );
      })}
    </div>
  );
};

// Badge compacto de reputacion
const ReputationBadge = ({ reputation }) => {
  if (!reputation || reputation.total_reviews === 0) {
    return <span className="text-xs text-gray-400 italic" data-testid="rep-no-reviews">Sin calificaciones</span>;
  }
  return (
    <div className="flex items-center gap-1" data-testid="rep-badge">
      <Stars value={reputation.avg_rating} size="sm" />
      <span className="text-xs font-medium text-gray-700">{reputation.avg_rating.toFixed(1)}</span>
      <span className="text-xs text-gray-400">({reputation.total_reviews})</span>
    </div>
  );
};

const CUALshareComponent = ({ user }) => {
  const [tab, setTab] = useState('explore');
  const [shares, setShares] = useState([]);
  const [myCreated, setMyCreated] = useState([]);
  const [myJoined, setMyJoined] = useState([]);
  const [myReputation, setMyReputation] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [selectedShare, setSelectedShare] = useState(null);
  const [reviewModal, setReviewModal] = useState(null); // { share_id, share_title }
  const [reviewForm, setReviewForm] = useState({ rating: 0, comment: '' });
  const [reviewsModal, setReviewsModal] = useState(null); // { share_id, share_title }
  const [reviewsList, setReviewsList] = useState([]);
  const [form, setForm] = useState({ title: '', description: '', category: 'transporte', total_cost_cc: '', total_slots: 2, duration_type: 'once', location: '', auto_execute: true });

  useEffect(() => {
    fetchData();
  }, [tab, selectedCategory]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [catRes] = await Promise.all([axios.get(`${API}/cualshare/categories`)]);
      setCategories(catRes.data.categories);

      if (tab === 'explore') {
        const params = { status: 'open', sort: 'reputation' };
        if (selectedCategory) params.category = selectedCategory;
        const res = await axios.get(`${API}/cualshare/explore`, { params });
        setShares(res.data.shares);
      } else if (tab === 'mine') {
        const res = await axios.get(`${API}/cualshare/my-shares`);
        setMyCreated(res.data.created);
        setMyJoined(res.data.joined);
        setMyReputation(res.data.my_reputation);
      }
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const createShare = async () => {
    if (!form.title || !form.total_cost_cc || form.total_slots < 2) return;
    try {
      await axios.post(`${API}/cualshare/create`, { ...form, total_cost_cc: parseFloat(form.total_cost_cc), total_slots: parseInt(form.total_slots) });
      setShowCreate(false);
      setForm({ title: '', description: '', category: 'transporte', total_cost_cc: '', total_slots: 2, duration_type: 'once', location: '', auto_execute: true });
      setTab('mine');
      fetchData();
    } catch (err) { alert(err.response?.data?.detail || 'Error'); }
  };

  const joinShare = async (shareId) => {
    try {
      await axios.post(`${API}/cualshare/${shareId}/join`, { slots: 1 });
      fetchData();
      setSelectedShare(null);
    } catch (err) { alert(err.response?.data?.detail || 'Error'); }
  };

  const completeShare = async (shareId) => {
    try {
      const res = await axios.post(`${API}/cualshare/${shareId}/complete`);
      alert(`Completado. Comision: ${res.data.commission} Cc. Neto: ${res.data.creator_net} Cc`);
      fetchData();
    } catch (err) { alert(err.response?.data?.detail || 'Error'); }
  };

  const cancelShare = async (shareId) => {
    if (!window.confirm('Cancelar recurso? Se devuelven los fondos a todos.')) return;
    try {
      await axios.post(`${API}/cualshare/${shareId}/cancel`);
      fetchData();
    } catch (err) { alert(err.response?.data?.detail || 'Error'); }
  };

  const leaveShare = async (shareId) => {
    try {
      await axios.post(`${API}/cualshare/${shareId}/leave`);
      fetchData();
    } catch (err) { alert(err.response?.data?.detail || 'Error'); }
  };

  const submitReview = async () => {
    if (!reviewModal || reviewForm.rating < 1) return;
    try {
      const payload = { rating: reviewForm.rating };
      if (reviewForm.comment.trim()) payload.comment = reviewForm.comment.trim();
      await axios.post(`${API}/cualshare/${reviewModal.share_id}/review`, payload);
      setReviewModal(null);
      setReviewForm({ rating: 0, comment: '' });
      fetchData();
    } catch (err) { alert(err.response?.data?.detail || 'Error al enviar calificacion'); }
  };

  const openReviewsList = async (share) => {
    try {
      const res = await axios.get(`${API}/cualshare/${share.id}/reviews`);
      setReviewsList(res.data.reviews);
      setReviewsModal({ share_id: share.id, share_title: share.title });
    } catch (err) { alert(err.response?.data?.detail || 'Error'); }
  };

  const costPerSlot = form.total_cost_cc && form.total_slots ? (parseFloat(form.total_cost_cc) / parseInt(form.total_slots)).toFixed(2) : '0';

  return (
    <div className="space-y-6" data-testid="cualshare-module">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-bold text-gray-800" data-testid="cualshare-title">CUALshare</h2>
          <p className="text-sm text-gray-500">Comparte recursos, divide costos</p>
        </div>
        <button onClick={() => setShowCreate(true)} data-testid="create-share-btn" className="px-4 py-2 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700 transition-all">
          + Compartir Recurso
        </button>
      </div>

      {/* Tabs */}
      <div className="flex gap-2 border-b border-gray-200 pb-1">
        {[{ id: 'explore', label: 'Explorar' }, { id: 'mine', label: 'Mis Recursos' }].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} data-testid={`tab-${t.id}`}
            className={`px-4 py-2 text-sm font-medium rounded-t-lg transition-all ${tab === t.id ? 'bg-teal-50 text-teal-700 border-b-2 border-teal-600' : 'text-gray-500 hover:text-gray-700'}`}>
            {t.label}
          </button>
        ))}
      </div>

      {/* Mi reputacion */}
      {tab === 'mine' && myReputation && (
        <div className="bg-gradient-to-r from-amber-50 to-yellow-50 border border-amber-200 rounded-xl p-4 flex items-center justify-between" data-testid="my-reputation-card">
          <div>
            <p className="text-xs text-amber-700 font-medium uppercase tracking-wide">Tu reputacion</p>
            <div className="flex items-center gap-2 mt-1">
              <Stars value={myReputation.avg_rating} size="md" />
              <span className="text-lg font-bold text-amber-900">
                {myReputation.total_reviews > 0 ? myReputation.avg_rating.toFixed(1) : '—'}
              </span>
              <span className="text-xs text-amber-700">
                ({myReputation.total_reviews} {myReputation.total_reviews === 1 ? 'calificacion' : 'calificaciones'})
              </span>
            </div>
          </div>
          {myReputation.total_reviews === 0 && (
            <p className="text-xs text-amber-600 italic max-w-[200px] text-right">Crea recursos y completa entregas para ganar reputacion</p>
          )}
        </div>
      )}

      {/* Filtro categorias */}
      {tab === 'explore' && (
        <div className="flex gap-2 flex-wrap">
          <button onClick={() => setSelectedCategory('')} className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${!selectedCategory ? 'bg-teal-600 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>Todos</button>
          {categories.map(c => (
            <button key={c.id} onClick={() => setSelectedCategory(c.id)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all flex items-center gap-1.5 ${selectedCategory === c.id ? 'bg-teal-600 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
              {CATEGORY_ICONS[c.id]} {c.name}
            </button>
          ))}
        </div>
      )}

      {loading ? (
        <div className="flex justify-center py-12"><div className="animate-spin w-8 h-8 border-3 border-teal-500 border-t-transparent rounded-full"></div></div>
      ) : tab === 'explore' ? (
        <div className="space-y-3">
          {shares.length === 0 ? (
            <div className="text-center py-12 text-gray-400">
              <p className="text-lg font-medium">No hay recursos compartidos</p>
              <p className="text-sm mt-1">Se el primero en compartir algo</p>
            </div>
          ) : shares.map(s => (
            <ShareCard key={s.id} share={s} onJoin={() => setSelectedShare(s)} onShowReviews={() => openReviewsList(s)} isCreator={s.creator_id === user?.id} />
          ))}
        </div>
      ) : (
        <div className="space-y-6">
          <div>
            <h3 className="text-sm font-semibold text-gray-700 mb-3">Recursos que creaste</h3>
            {myCreated.length === 0 ? <p className="text-sm text-gray-400">Ninguno aun</p> : (
              <div className="space-y-3">
                {myCreated.map(s => (
                  <ShareCard key={s.id} share={s} isCreator
                    onComplete={() => completeShare(s.id)}
                    onCancel={() => cancelShare(s.id)}
                    onShowReviews={() => openReviewsList(s)} />
                ))}
              </div>
            )}
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-700 mb-3">Recursos en los que participas</h3>
            {myJoined.length === 0 ? <p className="text-sm text-gray-400">Ninguno aun</p> : (
              <div className="space-y-3">
                {myJoined.map(s => (
                  <ShareCard key={s.id} share={s}
                    onLeave={() => leaveShare(s.id)}
                    onReview={s.status === 'completed' && !s.already_reviewed ? () => { setReviewModal({ share_id: s.id, share_title: s.title }); setReviewForm({ rating: 0, comment: '' }); } : null}
                    alreadyReviewed={s.already_reviewed}
                    onShowReviews={() => openReviewsList(s)} />
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modal Crear */}
      {showCreate && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" data-testid="create-share-modal">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg font-bold text-gray-800 mb-4">Compartir Recurso</h3>
            <div className="space-y-4">
              <input value={form.title} onChange={e => setForm({...form, title: e.target.value})} placeholder="Titulo del recurso" data-testid="share-title-input"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500" />
              <textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})} placeholder="Descripcion (opcional)" rows={2}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500" />
              <select value={form.category} onChange={e => setForm({...form, category: e.target.value})} data-testid="share-category-select"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm bg-white">
                {categories.map(c => <option key={c.id} value={c.id}>{c.name} — {c.examples}</option>)}
              </select>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="text-xs text-gray-500">Costo total (Cc)</label>
                  <input type="number" value={form.total_cost_cc} onChange={e => setForm({...form, total_cost_cc: e.target.value})} data-testid="share-cost-input"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
                </div>
                <div>
                  <label className="text-xs text-gray-500">Cupos</label>
                  <input type="number" min="2" value={form.total_slots} onChange={e => setForm({...form, total_slots: e.target.value})} data-testid="share-slots-input"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
                </div>
              </div>
              {form.total_cost_cc && form.total_slots >= 2 && (
                <div className="bg-teal-50 rounded-lg p-3 text-center">
                  <p className="text-xs text-teal-600">Costo por persona</p>
                  <p className="text-2xl font-bold text-teal-700" data-testid="cost-per-slot">{costPerSlot} Cc</p>
                </div>
              )}
              <select value={form.duration_type} onChange={e => setForm({...form, duration_type: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm bg-white">
                {Object.entries(DURATION_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
              <input value={form.location} onChange={e => setForm({...form, location: e.target.value})} placeholder="Ubicacion (opcional)"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
              <div className="flex gap-3 pt-2">
                <button onClick={() => setShowCreate(false)} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50">Cancelar</button>
                <button onClick={createShare} data-testid="submit-create-share" disabled={!form.title || !form.total_cost_cc}
                  className="flex-1 px-4 py-2 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700 disabled:opacity-50">Crear</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Unirse */}
      {selectedShare && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" data-testid="join-share-modal">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm">
            <h3 className="text-lg font-bold text-gray-800 mb-2">{selectedShare.title}</h3>
            <p className="text-sm text-gray-500 mb-3">{selectedShare.description || 'Sin descripcion'}</p>
            <div className="flex items-center gap-2 mb-4 text-xs text-gray-600">
              <span>Creador: <strong>{selectedShare.creator_name}</strong></span>
              <span>·</span>
              <ReputationBadge reputation={selectedShare.creator_reputation} />
            </div>
            <div className="bg-teal-50 rounded-lg p-4 mb-4 text-center">
              <p className="text-xs text-teal-600">Tu costo (1 cupo)</p>
              <p className="text-3xl font-bold text-teal-700">{selectedShare.cost_per_slot} Cc</p>
              <p className="text-xs text-gray-500 mt-1">{selectedShare.available_slots} cupos disponibles de {selectedShare.total_slots}</p>
            </div>
            <div className="flex gap-3">
              <button onClick={() => setSelectedShare(null)} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600">Cerrar</button>
              <button onClick={() => joinShare(selectedShare.id)} data-testid="confirm-join-btn"
                className="flex-1 px-4 py-2 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700">Unirme</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Calificar */}
      {reviewModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" data-testid="review-modal">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm">
            <h3 className="text-lg font-bold text-gray-800 mb-1">Califica tu experiencia</h3>
            <p className="text-sm text-gray-500 mb-4">{reviewModal.share_title}</p>
            <div className="flex justify-center mb-4">
              <Stars value={reviewForm.rating} size="lg" interactive onChange={v => setReviewForm({...reviewForm, rating: v})} />
            </div>
            <p className="text-xs text-center text-gray-500 mb-4" data-testid="review-rating-label">
              {reviewForm.rating === 0 ? 'Toca una estrella para calificar' :
               reviewForm.rating === 5 ? 'Excelente' :
               reviewForm.rating === 4 ? 'Muy bien' :
               reviewForm.rating === 3 ? 'Aceptable' :
               reviewForm.rating === 2 ? 'Regular' : 'Malo'}
            </p>
            <textarea
              value={reviewForm.comment}
              onChange={e => setReviewForm({...reviewForm, comment: e.target.value.slice(0, 500)})}
              placeholder="Comentario (opcional, max 500 caracteres)"
              rows={3}
              data-testid="review-comment-input"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500 resize-none"
            />
            <p className="text-xs text-gray-400 text-right mt-1">{reviewForm.comment.length}/500</p>
            <div className="flex gap-3 mt-4">
              <button onClick={() => { setReviewModal(null); setReviewForm({ rating: 0, comment: '' }); }} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600">Cancelar</button>
              <button onClick={submitReview} disabled={reviewForm.rating < 1} data-testid="submit-review-btn"
                className="flex-1 px-4 py-2 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700 disabled:opacity-50">Enviar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Lista de Reviews */}
      {reviewsModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" data-testid="reviews-list-modal">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md max-h-[80vh] overflow-y-auto">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h3 className="text-lg font-bold text-gray-800">Calificaciones</h3>
                <p className="text-sm text-gray-500">{reviewsModal.share_title}</p>
              </div>
              <button onClick={() => setReviewsModal(null)} className="text-gray-400 hover:text-gray-600 text-xl">×</button>
            </div>
            {reviewsList.length === 0 ? (
              <p className="text-sm text-gray-400 text-center py-8">Aun no hay calificaciones</p>
            ) : (
              <div className="space-y-3">
                {reviewsList.map(r => (
                  <div key={r.id} className="border border-gray-100 rounded-lg p-3" data-testid={`review-item-${r.id}`}>
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-sm font-medium text-gray-700">{r.reviewer_name}</span>
                      <Stars value={r.rating} size="sm" />
                    </div>
                    {r.comment && <p className="text-xs text-gray-600 mt-1">{r.comment}</p>}
                    <p className="text-xs text-gray-400 mt-1">{new Date(r.created_at).toLocaleDateString()}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const ShareCard = ({ share, isCreator, onJoin, onComplete, onCancel, onLeave, onReview, onShowReviews, alreadyReviewed }) => {
  const status = STATUS_LABELS[share.status] || STATUS_LABELS.open;
  const filledSlots = share.total_slots - share.available_slots;
  const fillPct = (filledSlots / share.total_slots) * 100;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 hover:shadow-sm transition-all" data-testid={`share-card-${share.id}`}>
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-teal-50 flex items-center justify-center text-teal-600">
            {CATEGORY_ICONS[share.category] || CATEGORY_ICONS.otro}
          </div>
          <div>
            <h4 className="text-sm font-semibold text-gray-800">{share.title}</h4>
            <p className="text-xs text-gray-400">{share.creator_name} · {DURATION_LABELS[share.duration_type]}</p>
            {share.creator_reputation && (
              <div className="mt-1">
                <ReputationBadge reputation={share.creator_reputation} />
              </div>
            )}
          </div>
        </div>
        <span className={`text-xs px-2 py-1 rounded-full font-medium ${status.color}`}>{status.text}</span>
      </div>

      {share.description && <p className="text-xs text-gray-500 mb-3">{share.description}</p>}

      <div className="flex items-center gap-4 mb-3">
        <div className="text-center">
          <p className="text-lg font-bold text-teal-700">{share.cost_per_slot} Cc</p>
          <p className="text-xs text-gray-400">por cupo</p>
        </div>
        <div className="flex-1">
          <div className="flex justify-between text-xs text-gray-500 mb-1">
            <span>{filledSlots}/{share.total_slots} cupos</span>
            <span>{share.available_slots} disponibles</span>
          </div>
          <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
            <div className="h-full bg-teal-500 rounded-full transition-all" style={{ width: `${fillPct}%` }} />
          </div>
        </div>
      </div>

      {share.location && <p className="text-xs text-gray-400 mb-3">Ubicacion: {share.location}</p>}

      <div className="flex flex-wrap gap-2">
        {onJoin && share.status === 'open' && !isCreator && (
          <button onClick={onJoin} data-testid={`join-btn-${share.id}`} className="flex-1 px-3 py-1.5 bg-teal-600 text-white rounded-lg text-xs font-medium hover:bg-teal-700">Unirme</button>
        )}
        {isCreator && share.status === 'active' && onComplete && (
          <button onClick={onComplete} data-testid={`complete-btn-${share.id}`} className="flex-1 px-3 py-1.5 bg-green-600 text-white rounded-lg text-xs font-medium hover:bg-green-700">Completar</button>
        )}
        {isCreator && share.status !== 'completed' && share.status !== 'cancelled' && onCancel && (
          <button onClick={onCancel} data-testid={`cancel-btn-${share.id}`} className="px-3 py-1.5 border border-red-300 text-red-600 rounded-lg text-xs font-medium hover:bg-red-50">Cancelar</button>
        )}
        {!isCreator && share.status === 'open' && onLeave && (
          <button onClick={onLeave} data-testid={`leave-btn-${share.id}`} className="px-3 py-1.5 border border-gray-300 text-gray-600 rounded-lg text-xs font-medium hover:bg-gray-50">Salirme</button>
        )}
        {onReview && (
          <button onClick={onReview} data-testid={`review-btn-${share.id}`} className="flex-1 px-3 py-1.5 bg-amber-500 text-white rounded-lg text-xs font-medium hover:bg-amber-600 flex items-center justify-center gap-1">
            <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
            Calificar
          </button>
        )}
        {alreadyReviewed && share.status === 'completed' && (
          <span className="px-3 py-1.5 bg-gray-100 text-gray-500 rounded-lg text-xs font-medium" data-testid={`reviewed-badge-${share.id}`}>Calificado</span>
        )}
        {share.status === 'completed' && onShowReviews && (
          <button onClick={onShowReviews} data-testid={`show-reviews-btn-${share.id}`} className="px-3 py-1.5 border border-gray-300 text-gray-600 rounded-lg text-xs font-medium hover:bg-gray-50">Ver calificaciones</button>
        )}
      </div>
    </div>
  );
};

export default CUALshareComponent;
